<template>
  <div
  :class="`d-flex justify-${justify}`">
    <v-chip
    ref="textRef"
    color="#007bff"
    class="white--text elevation-2"
    @click="copyText">
      <span
      v-if="!isCopied">
        {{id}}
      </span>
      <span
      v-else>
        {{$t("common.copied")}}
      </span>
    </v-chip>
  </div>
</template>

<script>
import { copyNonInput } from "@/utils/clipboardUtil"
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    justify: {
      type: String,
      default: "start"
    }
  },
  data: () => {
    return {
      isCopied: false
    }
  },
  methods: {
    copyText() {
      copyNonInput(String(this.id).trim(), (v) => this.isCopied = v)
    }
  }
}
</script>

<style>

</style>